import { render, staticRenderFns } from "./NewAsignacionAlimento.vue?vue&type=template&id=0afc8770&scoped=true"
import script from "./NewAsignacionAlimento.vue?vue&type=script&lang=js"
export * from "./NewAsignacionAlimento.vue?vue&type=script&lang=js"
import style0 from "./NewAsignacionAlimento.vue?vue&type=style&index=0&id=0afc8770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc8770",
  null
  
)

export default component.exports